import React,{useState} from 'react';
import {Link ,useParams} from 'react-router-dom';
import {ref,getDownloadURL,listAll} from "firebase/storage"
import {storage} from "../firebase.config";
import JSZip from 'jszip';
import {useDispatch} from 'react-redux';

const Breadcrumb = () =>{
    const param = useParams();
    const dispatch = useDispatch();

    const [isDownloading,setDownloading] = useState(false);
    const keys = Object.keys(param);
    // const [selectedOrder, setSelectedOrder] = useState('newToOld');

    const handleChange = (event) => {
      // setSelectedOrder(event.target.value);
      dispatch({type: event.target.value, payload: event.target.value.toLowerCase()})
    };

    const downloadFile = async (fullPath,itemName, lotFolder) => {
      const imageRef = ref(storage,fullPath);
      try {
        const downloadUrl = await getDownloadURL(imageRef);
        const response = await fetch(downloadUrl);
        const blob = await response.blob();
        lotFolder.file(itemName, blob, { binary: true });
      } catch (error) {
        console.error(`Error downloading file ${fullPath}: ${error.message}`);
      }
    };

    const loadLotFolder = async (prefix,currentDateFolder) => {
      const lotRef = ref(storage, prefix);
      try {
        const lots = await listAll(lotRef);
        // const lotName  = currentDateFolder.folder(prefix.fullPath.split('/').pop());
        await Promise.all(
          lots.items.map(async (item) => {
            const itemName = item.name.split('/').pop();
            // await downloadFile(`${prefix}/${itemName}`, itemName,lotName);
            await downloadFile(`${prefix}/${itemName}`, itemName,currentDateFolder);
          })
        );
      } catch (error) {
        console.error(`Error listing items in folder ${prefix}: ${error.message}`);
      }
    };

    const downloadFunction = async () => {
      const dateRef = ref(storage, `${param.username}/${param.date}`);  
      try {
          setDownloading(true)
          const folderList = await listAll(dateRef);
          const zip = new JSZip();
          const currentDateFolder = zip.folder(`${param.username}_${param.date}`);
          await Promise.all(
            folderList.prefixes.map(async (prefix) => {
                await loadLotFolder(prefix,currentDateFolder);
            })
          );
          
  
        // // Generate a zip file
        const zipBlob = await zip.generateAsync({ type: 'blob' });
        // Create a link and trigger a download
        const link = document.createElement('a');
        link.href = URL.createObjectURL(zipBlob);
        link.download = `${param.username}_${param.date}.zip`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setDownloading(false)
      } catch (error) {
        setDownloading(false)
        console.error('Error downloading images:', error);
      }
    };

    return(
        <nav aria-label="breadcrumb"  className ="download-btn-row" >
            <ol className="breadcrumb">
                <li className="breadcrumb-item"><a href="/">Home</a></li>
                {
                  keys.length  === 1  ?  
                  <li className="breadcrumb-item active text-capitalize">{param.username}</li>
                    : keys.length  === 2  ?
                    (<>  
                        <li className="breadcrumb-item text-capitalize"><Link to={`/${param.username}`}>{param.username}</Link></li>
                        <li className="breadcrumb-item active" >{param.date}</li>
                    </> )
                    :
                    (keys.length  === 3  ?
                      (<>  
                        <li className="breadcrumb-item text-capitalize"><Link to={`/${param.username}`}>{param.username}</Link></li>
                        <li className="breadcrumb-item text-capitalize" ><Link to={`/${param.username}/${param.date}`}>{param.date}</Link></li>
                        <li className="breadcrumb-item active" >{param.slot || param.folderPath}</li>
                    </> )
                    :
                    ""
                    )
                }
                
            </ol>
           
              {/* Sort by order */}
              <div style={{ display: 'flex'}}>
                  {
                    keys.length  === 2  &&
                    <button onClick={downloadFunction} disabled={isDownloading}  className="d-sm-inline-block btn btn-sm btn-primary shadow-sm download-btn mr-2">
                      {
                        isDownloading &&   
                        <div className="spinner-border" role="status"> 
                            <span className="sr-only">Loading...</span>
                        </div>
                      } 
                        Download
                    </button>
                }
                {/* <select id="folderOrder" onChange={handleChange} className=' btn-primary'>
                  <option value="ASCENDING">Ascending</option>
                  <option value="DESCENDING">Descending</option>
                </select> */}
              </div>
        </nav>
    );
}
export  default Breadcrumb;